import { render, staticRenderFns } from "./AddRoleDialog.vue?vue&type=template&id=d1611038"
import script from "./AddRoleDialog.vue?vue&type=script&lang=js"
export * from "./AddRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports